import { useMediaAiTrainingDataApi } from '@/common/api/modules/mediaAiTrainingData'
import {
  mediaAiTrainingDataArticleHtmlPath,
  mediaAiTrainingDataCommonRulesPath
} from '@/common/app/path'
import { useSiteId } from '@/common/app/site'
import { MediaAiTrainingData } from '@/common/model/media/mediaAiTrainingData'

import Button from '@/components/view/atoms/button/Button'
import TextButton from '@/components/view/atoms/button/TextButton'
import { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import IconText from '@/components/view/atoms/icon/IconText'
import SimpleTable from '@/components/view/atoms/table/SimpleTable'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import Area from '@/components/view/layouts/area/Area'
import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import MainInnerLoader from '@/components/container/MainInnerLoader'
import AppTitleBadge, { AppTitleBadgeType } from '@/components/container/layout/AppTitleBadge'

interface TrainingDataEntry {
  name: string
  path(siteId: number): string
  // 当該項目が登録済みか（未登録は空文字で表す）
  registered(data: MediaAiTrainingData | undefined): boolean
}

// 設定項目は並列に並べる（種別による入れ子にはしない）。項目が増えたらここへ足す。
const ENTRIES: TrainingDataEntry[] = [
  {
    name: '記事HTML',
    path: mediaAiTrainingDataArticleHtmlPath,
    registered: (data) => !!data?.article_html
  },
  {
    name: '共通ルール',
    path: mediaAiTrainingDataCommonRulesPath,
    registered: (data) => !!data?.restrictions
  }
]

const MediaAiTrainingDataPage = () => {
  const siteId = useSiteId()
  const { data, error } = useMediaAiTrainingDataApi({ site_id: siteId })

  return (
    <Main type={MainLayoutType.SMALL} bottomSpace>
      <PageTitle
        title={'AI学習用データ'}
        badgeNode={<AppTitleBadge type={AppTitleBadgeType.MEDIA} />}
        description='AIが記事を生成・リライト・診断する際に参照する、このサイト固有のデータです。'
      />
      <Content>
        <MainInnerLoader error={error} data={data}>
          <Area noBorder>
            <SimpleTable noMargin>
              <thead>
                <TableRow head>
                  <TableRowItem>
                    <Text size={12} color={TextColor.SECONDARY}>
                      フォーマット名
                    </Text>
                  </TableRowItem>
                  <TableRowItem width={160}>
                    <Text size={12} color={TextColor.SECONDARY}>
                      登録情報
                    </Text>
                  </TableRowItem>
                </TableRow>
              </thead>
              <tbody>
                {ENTRIES.map((entry) => (
                  <TableRow key={entry.name}>
                    <TableRowItem>
                      <TextButton link={entry.path(siteId)}>{entry.name}</TextButton>
                    </TableRowItem>
                    <TableRowItem>
                      {entry.registered(data) ? (
                        <IconText
                          text={'登録済み'}
                          iconType={IconType.CIRCLE_CHECK}
                          color={IconColor.SUCCESS}
                          textColor={TextColor.SUCCESS}
                          direction='horizon'
                          textSize={12}
                          noBold
                        />
                      ) : (
                        <Button link={entry.path(siteId)}>登録する</Button>
                      )}
                    </TableRowItem>
                  </TableRow>
                ))}
              </tbody>
            </SimpleTable>
          </Area>
        </MainInnerLoader>
      </Content>
    </Main>
  )
}

export default MediaAiTrainingDataPage
